import React, { useEffect, useState } from 'react';
import Template from '../../../components/organisms/Template';
import { Row, Col, Form } from 'react-bootstrap';
import InputText from '../../../components/atoms/InputText';
import { getUser, editUser } from '../../../services/Users';
import { getIdFromUrlLocationPathname, formatDateTime } from '../../../helpers/functions';
import useForm from '../../../helpers/formHelper';
import ButtonSubmit from '../../../components/atoms/ButtonSubmit';
import ButtonBar from '../../../components/molecules/ButtonBar';
import { useAlert } from 'react-alert';
import Session from '../../../components/atoms/Session';
import PageHeader from '../../../components/molecules/PageHeader';

function Edit(props) {

  const [loading, setLoading] = useState(true);
  const alert = useAlert();

  const [data, setData] = useState();
  const [validated, setValidated] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  const { inputs, handleInputChange, setInputs, validateInputs } = useForm();

  const id = getIdFromUrlLocationPathname(props.history.location.pathname);

  const addValidationError = (validationError) => {
    let validationsError = validationErrors.slice();
    validationsError.push(validationError);
    setValidationErrors(validationsError);
  }

  const edit = async () => {
    setLoading(true);
    const response = await editUser(id, {
      nome: inputs.nome,
      sobrenome: inputs.sobrenome
    }, alert, addValidationError);

    if (response) {
      props.history.push(`/user/detail/${id}`);
      alert.success('Usuário editado com sucesso');
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const result = await getUser(id, alert);
      if (result) {
        setInputs({ ...result });
      }
      if (result && result.data) {
        setData(new Date(result.data));
      }
      setLoading(false);
    };

    fetchData();
  }, [id, setInputs]);

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const errors = validateInputs({ page: 'editUser', data });
      if (errors && errors.length > 0) {
        event.stopPropagation();
        setValidationErrors(errors);
      } else {
        edit();
      }
    }

    setValidated(true);
  };

  return (
    <Template validationErrors={validationErrors} clearErrosFunc={() => setValidationErrors([])}
      loading={loading}>
      <PageHeader tittle="Editar Usuário" />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row>
          <Col>
            <InputText id="login" name="Login" value={inputs.login || ''}
              onChange={handleInputChange} disabled />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputText id="nome" name="Nome" value={inputs.nome || ''}
              onChange={handleInputChange} />
          </Col>
          <Col>
            <InputText id="sobrenome" name="Sobrenome" value={inputs.sobrenome || ''}
              onChange={handleInputChange} />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputText id="perfil" name="Perfil" value={inputs.perfil || ''}
              onChange={handleInputChange} disabled />
          </Col>
          <Col>
            <InputText id="visivel" name="Visível" value={inputs.visivel || ''}
              onChange={handleInputChange} disabled />
          </Col>
        </Row>
        <Session name="Informações">
            <Row>
              <Col>
                <InputText name="Criado Por" value={inputs?.responsavel?.nome || ''} disabled />
              </Col>
              <Col>
                <InputText name="Data Criação"
                  value={inputs.dataHoraCriacao ? formatDateTime(inputs.dataHoraCriacao) : ''} disabled />
              </Col>
            </Row>
          </Session>
        <ButtonBar>
          <ButtonSubmit variant="success" type="submit">Salvar</ButtonSubmit>
        </ButtonBar>
      </Form>
    </Template>
  );
}

export default Edit;